
document.documentElement.classList.add('f10-motion');

document.addEventListener('DOMContentLoaded', () => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Direct checkout */
  document.querySelectorAll('[data-direct-checkout-form]').forEach(form => {
    form.addEventListener('submit', async (event) => {
      const button = form.querySelector('[data-direct-checkout]');
      if (!button || button.dataset.mode !== 'checkout') return;
      event.preventDefault();
      button.disabled = true;
      const original = button.textContent;
      button.textContent = 'Opening checkout…';
      try {
        const data = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method:'POST',
          body:data,
          headers:{'Accept':'application/json'}
        });
        if (!res.ok) throw new Error('cart add failed');
        window.location.href='/checkout';
      } catch(e) {
        button.disabled=false;
        button.textContent=original;
        form.submit();
      }
    });
  });

  /* Lightbox */
  const box = document.querySelector('.f10-lightbox');
  const boxImg = box ? box.querySelector('img') : null;
  const close = () => {
    if(box){
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden','true');
      if(boxImg) boxImg.removeAttribute('src');
    }
  };
  document.querySelectorAll('[data-zoom-image]').forEach(el => {
    el.setAttribute('role','button');
    el.setAttribute('tabindex','0');
    const openZoom = () => {
      if(!box || !boxImg) return;
      const img = el.tagName === 'IMG' ? el : el.querySelector('img');
      if(!img) return;
      boxImg.src = img.currentSrc || img.src;
      boxImg.alt = img.alt || 'Product preview';
      box.classList.add('is-open');
      box.setAttribute('aria-hidden','false');
    };
    el.addEventListener('click', openZoom);
    el.addEventListener('keydown', e => {
      if(e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        openZoom();
      }
    });
  });
  if(box){
    box.addEventListener('click', e => {
      if(e.target === box || e.target.closest('[data-lightbox-close]')) close();
    });
    document.addEventListener('keydown', e => {
      if(e.key === 'Escape') close();
    });
  }

  /* Scroll reveal */
  const revealSelectors = [
    '.f10-h1','.f10-h2','.f10-lead','.f10-editorial-quote',
    '.f10-shift','.f10-step','.f10-product-feature','.f10-deliverable',
    '.f10-lesson-card','.f10-week','.f10-difference','.f10-module',
    '.f10-card','.f10-journey-card','.f10-offer-shell'
  ];
  const revealEls = [...document.querySelectorAll(revealSelectors.join(','))];
  revealEls.forEach((el,i) => {
    el.classList.add('f10-reveal');
    el.dataset.delay = String(i % 5);
  });

  if(!reduced && 'IntersectionObserver' in window){
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:0.12, rootMargin:'0px 0px -4% 0px'});
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-visible'));
  }

  /* Scroll progress + header depth */
  const progress = document.querySelector('.f10-progress');
  const header = document.querySelector('.f10-header');
  let ticking = false;
  const onScroll = () => {
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const p = max > 0 ? window.scrollY / max : 0;
      if(progress) progress.style.transform = `scaleX(${Math.max(0,Math.min(1,p))})`;
      if(header) header.classList.toggle('is-scrolled', window.scrollY > 20);
      ticking = false;
    });
  };
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();

  if(!reduced){
    /* Cursor spotlight */
    let targetX = window.innerWidth * .5;
    let targetY = window.innerHeight * .35;
    let currentX = targetX, currentY = targetY;
    window.addEventListener('pointermove',e => {
      targetX = e.clientX; targetY = e.clientY;
    },{passive:true});
    const glowLoop = () => {
      currentX += (targetX-currentX)*.08;
      currentY += (targetY-currentY)*.08;
      document.documentElement.style.setProperty('--mx', currentX+'px');
      document.documentElement.style.setProperty('--my', currentY+'px');
      requestAnimationFrame(glowLoop);
    };
    glowLoop();

    /* Premium tilt for product visuals and lesson cards */
    const tiltEls = document.querySelectorAll('.f10-product-visual,.f10-lesson-card');
    tiltEls.forEach(el => {
      const strength = el.classList.contains('f10-product-visual') ? 5 : 3.2;
      el.addEventListener('pointermove',e => {
        if(window.innerWidth < 821) return;
        const r = el.getBoundingClientRect();
        const x = (e.clientX-r.left)/r.width - .5;
        const y = (e.clientY-r.top)/r.height - .5;
        el.style.transform = `perspective(950px) rotateX(${(-y*strength).toFixed(2)}deg) rotateY(${(x*strength).toFixed(2)}deg) translateY(-4px)`;
      });
      el.addEventListener('pointerleave',() => {
        el.style.transform = '';
      });
    });

    }
});
